const INVALID_BRANCH_NAME_PATTERN = /(^(\.|\/))|((\.lock|\/)$)|[\^:~*\\\s\p{Cc}]|\.{2}|\/{2}|\/\.|@\{|\.lock\//iu;

export const validateBranchName = (rawValue: string, isBranchRequired: boolean | undefined) => {
  if (isBranchRequired && rawValue.length === 0) {
    return false;
  }
  return !INVALID_BRANCH_NAME_PATTERN.test(rawValue);
};
